module.exports = __webpack_public_path__ + "img/square-i.63be3243.svg";